import { useContext } from 'react';
import { LocaleContext } from '../providers/LocaleContext';

// ----------------------------------------------------------------------

const useLocales = () => {
  const context = useContext(LocaleContext);

  if (!context) {
    throw new Error('useLocales must be used within a LocaleProvider');
  }

  return context;
};

export default useLocales;
